const AdserverBase = require('../adserverBase');
const { makeEvents } = require('./divSlotAdserverUtils');

class DivSlotAdserver extends AdserverBase {
	static staticInit() {
		this.events = makeEvents();
	}

	getEventIfs() {
		return this.constructor.events;
	}

	get events() {
		return this.getEventIfs();
	}

	static destroySlots() {
		this.events.onSlotsDestroyed();
	}

	sendAdserverRequest(params) {
		for (const slot of [...params.unknownSlotsToLoad, ...params.usedUnitDatas.map((data) => data.slot)]) {
			this.events.slotRequested({ slot });
		}
		this.sendAdserverRequestSpecific(params);
	}
}

module.exports = DivSlotAdserver;
